export const HOTEL_SEARCH_NEW_FILTER_OPTIONS = new Set(['homes_villas'])

export type HomesAndVillasPopularFilterId = 'pet_friendly' | 'pool' | 'bedrooms_2' | 'kitchenette' | 'parking'

export type HomesAndVillasPopularFilter =
  | { id: HomesAndVillasPopularFilterId, param: 'holidayTypes' | 'propertyFacilities' | 'amenities', value: string }
  | { id: HomesAndVillasPopularFilterId, param: 'bedroomsGte', value: number }

// Hardcoded until there is enough Homes & Villas traffic to derive popular filters from data
export const HOMES_AND_VILLAS_POPULAR_FILTERS: ReadonlyArray<HomesAndVillasPopularFilter> = [
  { id: 'pet_friendly', param: 'holidayTypes', value: 'pet_friendly' },
  { id: 'pool', param: 'propertyFacilities', value: 'pool' },
  { id: 'bedrooms_2', param: 'bedroomsGte', value: 2 },
  { id: 'kitchenette', param: 'amenities', value: 'kitchenette' },
  { id: 'parking', param: 'propertyFacilities', value: 'parking' },
]
